<article
  class="w-full overflow-hidden rounded-xl card-item-1 shadow-sm border border-solid bg-white h-[23rem] min-w-[11rem] "
  (click)="navigatorVal ? goToSimilarHotel(dataSource.Url, $event) : {}">
  <img class="w-full object-cover h-40" [ngSrc]="dataSource.PictureUrl" height="192" width="210"
    (click)="goToSimilarHotel(dataSource?.Url, $event)"
    (error)="dataSource.PictureUrl = cdnUrl + '/images/no-image.jpg'" [alt]="dataSource.PictureName" />
  <div class="flex flex-col gap-2 py-2 px-3 justify-between" style="height: calc(100% - 10rem);">
   

    <div *ngIf="type === 2" class="flex flex-col gap-2" 
    [ngClass]="accommodation() == 'ecolodge' ? 'h-[85px]' : 'h-auto'">
    <div class="flex flex-col gap-1">
      <h6 class="font-bold text-sm truncate">
        <a [href]="dataSource.Url" (click)="goToSimilarHotel(dataSource.Url, $event)" [title]="dataSource.HotelName">
          {{ dataSource.HotelName }}
        </a>
      </h6>
      <ng-container *ngIf="accommodation() != 'ecolodge'">
        <iho-stars-rate *ngIf="dataSource?.HotelGrade !== 0" [rating]="
          dataSource?.HotelGrade
          || (dataSource?.Star?.StarClassName ?? 's-5' | extractGrade)" />
    
      </ng-container>
    
    </div>
      <div class="flex items-center gap-2" *ngIf="dataSource?.Description">
        <i class="ico-Users text-black-300 text-large"></i>
        <!-- TODO what is address ? -->
        <span class="text-black-300 text-xs truncate"
          [title]="dataSource?.Description">{{dataSource?.Description}}</span>
      </div>
      <div class="flex items-center gap-2" *ngIf="dataSource?.Address">
        <i class="ico-Location text-muted text-large"></i>
        <span class="text-black-300  text-xs  truncate" [title]="dataSource?.Address">{{ dataSource?.Address }}</span>
      </div>

      <div class="flex w-100 items-center" *ngIf=" dataSource?.Score?.ScoreNumber">
        <div class="grade h-8 w-8 flex items-center justify-center">
          <span>{{ dataSource?.Score?.ScoreNumber }}</span>
        </div>
        <div class="ms-3">
          <p class="font-bold text-blue-500 text-sm">{{ dataSource?.Score?.Text }}</p>
          <p class="text-xs" *ngIf="dataSource?.Score?.Description">({{ dataSource?.Score?.Description }})</p>
        </div>
      </div>
    </div>
    <div class="h-[60px] w-full">
      <div class="flex w-full items-center justify-end h-[32px]">
        <ng-container  *ngIf="dataSource?.Price?.OldPrice && dataSource?.Discount?.Discount && dataSource.Discount.Discount > 5">
    <span class="price-off mx-2 after:content-[''] line-through-price text-xs !font-normal">
      {{ dataSource.Price.BoardPrice | toToman | number: '2.' }}
    </span>
    <div class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
      <!-- <span class="text-sm text-green-800">{{ ds?.DiscountBalloon?.Discount }}%</span> -->
      <span class="text-sm text-green-800 !font-medium">{{ dataSource.Discount.Discount }}%</span>

    </div>
        </ng-container>
    
      </div>
      <div class="flex w-full items-center gap-1 justify-end">
        <span class="text-sm text-muted">{{ dataSource?.Price?.Nights }} شب</span>
        <span class="text-black text-lg font-bold">
          {{
          (dataSource?.Price?.IhoPrice) ? (dataSource.Price.IhoPrice | toToman | number: '2.') : (0)
          }}
        </span>
        <span class="text-sm text-muted">تومان</span>
      </div>
    </div>
  </div>
</article>